// extracted by mini-css-extract-plugin
module.exports = {"shopSection01__link":"ShopSection01_shopSection01__link__ad0qd"};